var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 153,
    viewBox: "0 0 152 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 152,
    height: 152,
    rx: 76,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 152,
    height: 152,
    rx: 76,
    fill: "#027880"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupIcon);
export default __webpack_public_path__ + "static/media/groupIcon.6640a1bf244c9c0e5bd7be36c39ed6d2.svg";
export { ForwardRef as ReactComponent };